import React from "react";
import TextQuestion from "./TextQuestion";
import NumberQuestion from "./NumberQuestion";
import DropDownQuestion from "./DropDownQuestion";
import DecimalQuestion from "./DecimalQuestion";
import CheckboxQuestion from "./CheckboxQuestion";
import SketchQuestion from "./SketchQuestion";
import FileUploadQuestion from "./FileUploadQuestion";
import FollowupGridContainer from "../../../admin/relatedWork/FollowupGridContainer";

export const QuestionComponentMap = {
    text: TextQuestion,
    dropdown: DropDownQuestion,
    number: NumberQuestion,
    decimal: DecimalQuestion,
    checkbox: CheckboxQuestion,
    sketch: SketchQuestion,
    file: FileUploadQuestion,
};

//We can pass in a custom container for the questions if needed, or default to the one used in Admin Related Work
export const getQuestionComponentByKey = (key = "text", props = {}, ContainerComponent = FollowupGridContainer) => {
    const Component = QuestionComponentMap?.[key] || TextQuestion;
    return (
        <ContainerComponent key={props.question.id}>
            <Component {...props} />
        </ContainerComponent>
    );
};
